import React from 'react';
import { Link } from 'react-router-dom';
import { FiCompass, FiMail, FiMapPin, FiPhone } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="px-4 pb-6 pt-12 sm:px-6">
    <div className="content-width">
      <div className="glass-panel overflow-hidden px-6 py-8 sm:px-8">
        <div className="grid gap-8 lg:grid-cols-[1.2fr_0.8fr_0.8fr]">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-teal-700 to-sky-700">
                <img src="/logo.png" alt="RahVan" className="h-8 w-8 object-contain" />
              </div>
              <div>
                <p className="font-serif text-2xl font-semibold text-slate-900">RahVan</p>
                <p className="text-xs uppercase tracking-[0.24em] text-stone-500">{t('design.footer.tagline')}</p>
              </div>
            </div>
            <p className="max-w-xl text-sm leading-7 text-slate-600">
              {t('design.footer.description')}
            </p>
          </div>

          <div>
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.24em] text-stone-500">{t('design.footer.explore')}</p>
            <div className="grid gap-3 text-sm text-slate-700">
              <Link to="/hotels" className="hover:text-teal-700">{t('nav.hotels')}</Link>
              <Link to="/tours" className="hover:text-teal-700">{t('nav.tours')}</Link>
              <Link to="/touristic-places" className="hover:text-teal-700">{t('nav.places')}</Link>
              <Link to="/contact" className="hover:text-teal-700">{t('nav.contact')}</Link>
            </div>
          </div>

          <div>
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.24em] text-stone-500">{t('design.footer.contact')}</p>
            <div className="space-y-3 text-sm text-slate-700">
              <p className="flex items-center gap-3"><FiMapPin className="text-teal-700" /> {t('design.footer.location')}</p>
              <p className="flex items-center gap-3"><FiMail className="text-teal-700" /> info@rahvantour.com</p>
              <p className="flex items-center gap-3"><FiPhone className="text-teal-700" /> +90 432 123 45 67</p>
              <p className="flex items-center gap-3"><FiCompass className="text-teal-700" /> {t('design.footer.serviceLine')}</p>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-stone-200 pt-4 text-xs uppercase tracking-[0.2em] text-stone-500">
          {new Date().getFullYear()} RahVan. {t('design.footer.copyright')}
        </div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
